import { render, staticRenderFns } from "./CreateNewPassword.vue?vue&type=template&id=6d0af60c"
import script from "./CreateNewPassword.vue?vue&type=script&lang=js"
export * from "./CreateNewPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports